















































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import cPopup from '@/components/default/Popup.vue';
import CompanyDetailsDialog from '@/components/crm/company/CompanyDetailsDialog.vue';

import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel } from 'devextreme-vue/form';

@Component({
  components: {
    cCard,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxItem,
    DxLabel,
    CompanyDetailsDialog,
  },
})
export default class CompanyDetailsCard extends Vue {
  @Prop({ required: true })
  public company!: ICompany | ISubcontractor;

  public showEditAddressModal: boolean = false;
  public showRemoveAddressModal: boolean = false;
  editableAddress: IAddress | null = null;
  selectedIndex?: number;

  addressTypes: any[] = [
    { value: 0, text: 'Standaard' },
    { value: 1, text: 'Leveradres' },
    { value: 2, text: 'Factuur adres' },
    { value: 3, text: 'Bezoek adres' },
  ];

  addAddress() {
    this.editableAddress = {
      name: 'default',
      type: 0,
      addressline1: '',
      addressline2: '',
      zip: '',
      city: '',
      country: '',
    };
    this.selectedIndex = -1;
    this.showEditAddressModal = true;
  }

  editAddress(index: number) {
    this.selectedIndex = index;
    if (this.company.addresses === null) {
      this.company.addresses = [];
    }
    this.editableAddress = Object.assign({}, this.company.addresses[index]);
    this.showEditAddressModal = true;
  }

  confirmDeleteAddress(index: number) {
    this.selectedIndex = index;
    if (this.company.addresses === null) {
      this.company.addresses = [];
    }
    this.editableAddress = Object.assign({}, this.company.addresses[index]);
    this.showRemoveAddressModal = true;
  }

  getAddressType(type: number) {
    return type !== undefined ? this.addressTypes.find((addresstype: any) => addresstype.value === type).text : '';
  }

  companyUpdated() {
    this.$emit('updated');
  }

  saveAddress() {
    this.$emit('saveAddress', this.editableAddress, this.selectedIndex);
  }

  deleteAddress() {
    this.$emit('deleteAddress', this.selectedIndex);
  }

  openEditCompanyDialog() {
    (this.$refs.editCompanyDialog as CompanyDetailsDialog).show = true;
  }

  get addressTypeOptions() {
    return { items: this.addressTypes, valueExpr: 'value', displayExpr: 'text' };
  }

  get isSubcontractor() {
    return this.company?.type === 'Subcontractor';
  }
}
